$(document).on('click', '.navigation-btn', function (e) {
    e.preventDefault();

    if($(this).hasClass('open')) {
        $(this).removeClass('open');
    }else{
        $(this).addClass('open');
    }
});

// Barvu kolečka potřebuje jak showAlergens(), tak handler zavírání tooltipu při
// kliknutí mimo (níže v $(document).ready). Musí proto zůstat na téhle úrovni —
// zanořená uvnitř showAlergens() házela tomu handleru ReferenceError při KAŽDÉM
// kliknutí na stránce s alergenovými kolečky. jQuery po výjimce přeskočí zbylé
// handlery téže události, takže tím padalo i objednávání (.ajax-send).
function getCircleColor(button) {
    if (button.data('circle-color')) {
        return button.data('circle-color');
    }

    var rootStyles = getComputedStyle(document.documentElement);
    var color = rootStyles.getPropertyValue('--order-buttons-color').trim()
        || rootStyles.getPropertyValue('--color-primary').trim()
        || '#024f94';

    button.data('circle-color', color);
    return color;
}

function showAlergens(elem) {
    var tooltip = elem.parent().find('.alergens-list-mobile');
    var allCircleButtons = $(document).find('.alergens-mobile-circle');

    // Pokud je tooltip uvnitř PO modálního overflow containeru, ořeže ho — proto ho
    // dynamicky přemístíme do <body> a po zavření vrátíme zpět. Scope omezený striktně
    // na PO modal — kdyby admin firmy měla custom CSS s overflow-y:auto někde v ancestor
    // chainu klasického menu, generic detekce by tooltip přesouvala mimo PO scope a ztratila
    // by parent CSS scope (regression risk).
    function detachTooltipForOverflowParent(t) {
        if (t.data('original-parent')) return; // už přemístěn
        // Portál spouštět JEN uvnitř PO modálu (kde víme, že overflow context je problém).
        if (t.closest('.permanent-offer-modal-wrap, .permanent-offer-modal-content-wrap').length === 0) return;
        var overflowParent = t.parents().filter(function () {
            var ov = $(this).css('overflow-y');
            return ov === 'auto' || ov === 'scroll';
        }).first();
        if (overflowParent.length === 0) return;
        var rect = elem[0].getBoundingClientRect();
        t.data('original-parent', t.parent());
        t.data('original-next-sibling', t.next());
        // Když přesouváme tooltip do body, ztratí stylování (CSS pravidla jsou nested
        // uvnitř .food-cart). Přidáme override class — globální styling pro portal mod.
        t.addClass('alergens-list-portal');
        t.css({
            position: 'fixed',
            top: (rect.bottom + 4) + 'px',
            left: Math.max(8, rect.left - 100) + 'px',
            'z-index': 3500,
        });
        $('body').append(t);
    }
    function reattachTooltip(t) {
        var origParent = t.data('original-parent');
        if (!origParent) return;
        var origSibling = t.data('original-next-sibling');
        t.css({ position: '', top: '', left: '', 'z-index': '' });
        t.removeClass('alergens-list-portal');
        if (origSibling && origSibling.length) {
            origSibling.before(t);
        } else {
            origParent.append(t);
        }
        t.removeData('original-parent');
        t.removeData('original-next-sibling');
    }

    function applyCircleDefault(button) {
        if (!button.hasClass('alergens-mobile-circle')) {
            return;
        }
        var color = getCircleColor(button);
        button.css('background-color', '#fff');
        button.css('color', color);
    }

    function applyCircleActive(button) {
        if (!button.hasClass('alergens-mobile-circle')) {
            return;
        }
        var color = getCircleColor(button);
        button.css('background-color', color);
        button.css('color', '#fff');
    }

    if(tooltip.is(':visible')){
        if(elem.hasClass('open')) {
            elem.removeClass('open');
        }

        allCircleButtons.each(function () {
            applyCircleDefault($(this));
        });
        $(document).find('.alergens-list-mobile').each(function () {
            reattachTooltip($(this));
        });
        $(document).find('.alergens-list-mobile').hide(); // Hide all
    }else{
        allCircleButtons.each(function () {
            var button = $(this);
            button.removeClass('open');
            applyCircleDefault(button);
        });

        elem.addClass('open');
        applyCircleActive(elem);

        $(document).find('.alergens-list-mobile').each(function () {
            reattachTooltip($(this));
        });
        $(document).find('.alergens-list-mobile').hide(); // Hide all
        detachTooltipForOverflowParent(tooltip);
        tooltip.show();
    }
}

function showIngredients(elem) {
    var tooltip = elem.parent().find('.slozeni-list-mobile');

    if(tooltip.is(':visible')){
        if(elem.hasClass('open')) {
            elem.removeClass('open');
        }

        $(document).find('.slozeni-list-mobile').hide();
    }else{
        elem.addClass('open');

        $(document).find('.slozeni-list-mobile').hide();
        tooltip.show();
    }
}

$(document).ready(function(){

    $(document).click(function(e) {
        if ( $(e.target).closest('.alergens-mobile').length === 0 ) {
            $(document).find('.alergens-mobile-circle').each(function () {
                var button = $(this);
                button.removeClass('open');
                var color = getCircleColor(button);
                button.css('background-color', '#fff');
                button.css('color', color);
            });
            $(document).find('.alergens-list-mobile').hide(); // Hide all
        }
        if ( $(e.target).closest('.slozeni-mobile').length === 0 ) {
            $(document).find('.slozeni-list-mobile').hide();
        }
    });
    $(document).on('click', '.alergens-mobile', function(e){
        e.preventDefault();
        showAlergens($(this));
    });
    $(document).on('touch', '.alergens-mobile', function(e){
        e.preventDefault();
        showAlergens($(this));
    });
    $(document).on('click', '.slozeni-mobile-btn', function(e){
        e.preventDefault();
        showIngredients($(this));
    });
    $(document).on('touch', '.slozeni-mobile-btn', function(e){
        e.preventDefault();
        showIngredients($(this));
    });

    var modal = document.getElementById('modal-login');
    var btn = document.getElementById('modal-button');
    var span = document.getElementsByClassName('close')[0];

    if(btn){
        // When the user clicks the button, open the modal
        btn.onclick = function() {
            modal.style.display = 'block';
        };
    }

    if(span){
        // When the user clicks on <span> (x), close the modal
        span.onclick = function() {
            modal.style.display = 'none';
        };
    }

    var modalSearch = document.getElementById('modal-search');
    // var btnSearch = document.getElementById('open-search-modal');
    var spanSearch = document.getElementById('close-search');
    var modalRemaining = document.getElementById('modal-remaining');
    var spanRemaining = document.getElementById('close-remaining');

    // When the user clicks the button, open the modal
    $(document).on('click', '#open-search-modal', function (){
        modalSearch.style.display = 'block';
        $(document).find('#search-user').focus();
    });

    if(spanSearch){
        // When the user clicks on <span> (x), close the modal
        spanSearch.onclick = function() {
            modalSearch.style.display = 'none';
        };
    }

    if(spanRemaining){
        // When the user clicks on <span> (x), close the modal
        spanRemaining.onclick = function() {
            modalRemaining.style.display = 'none';
        };
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
        if (event.target === modalSearch) {
            modalSearch.style.display = 'none';
        }
        if (event.target === modalRemaining) {
            modalRemaining.style.display = 'none';
        }
    };

    $(document).on('click', '.nav-admin', function (e){
        e.preventDefault();
        window.location.href = $(this).find('a').attr('href');
    });

});

$(document).on("click", ".modal-ask", function (e) {
    e.preventDefault();
    let link = $(this);
    let ask = "Opravdu chcete odebrat tento záznam?";

    if(isDefined(link.data("ask"))){
        ask = link.data("ask");
    }

    let confirmDialog = new ConfirmDialog(ask, {
        event: e
    });

    confirmDialog.create(function (result) {
        if(result){
            let url = link.data("href");
            let ajax = link.data("ajax");

            if(ajax === "on") {
                $.nette.ajax({
                    url: url,
                    type: 'GET',
                    off: {
                        snippets: true
                    }
                });
            } else {
                window.location.href = url;
            }
        }
    });

});

let creditSticker;
let eshopModeCart;
var stickyOffset;
$(document).ready(function() {
    var header = $('#header-container'); // Vyberte element hlavičky
    if(!header) return;
    stickyOffset = header.outerHeight(); // Aktualizace pozice hlavičky
    creditSticker = $(document).find(".credit-sticker");
    eshopModeCart = $('.restaurant-name > .food-basket');
    if(creditSticker) {
        $(window).scroll(function() {
            checkCreditSticker();
        });
    }
});

function checkCreditSticker(){
    if (window.scrollY > stickyOffset) {
        if(!creditSticker.isVisible()){
            creditSticker.show();
            eshopModeCart.hide();
        }
    } else {
        if(creditSticker.isVisible()){
            creditSticker.hide();
            eshopModeCart.show();
        }
    }
}

$( document ).on( "ajaxComplete", function() {
    creditSticker = $(document).find(".credit-sticker");
    if (creditSticker) {
        checkCreditSticker();
    }
} );

class CompanyWhisperer {
    constructor(inputSelector, suggestionsSelector, searchUrl) {
        this.input = $(inputSelector);
        this.suggestionsContainer = $(suggestionsSelector);
        this.clearButton = this.input.siblings('.clear-company');
        this.currentIndex = -1;
        this.suggestions = [];
        this.searchTimeout = null;
        this.isVisible = false;
        this.searchUrl = searchUrl;
        this.lastQuery = '';
        this.isSearching = false;

        // Lokalizované texty (nastavuje šablona přes window.whispererTexts.company); fallback čeština.
        const t = (window.whispererTexts && window.whispererTexts.company) || {};
        this.texts = {
            searching: t.searching || 'Vyhledávám firmy...',
            notFound: t.notFound || 'Žádné firmy nebyly nalezeny',
            unknownCompany: t.unknown || 'Neznámá firma',
            autofilled: t.autofilled || 'Údaje firmy byly automaticky vyplněny',
        };

        this.init();
    }

    init() {
        this.input.off('input.companyWhisperer keydown.companyWhisperer focus.companyWhisperer blur.companyWhisperer');

        this.input.on('input.companyWhisperer', (e) => this.handleInput(e));
        this.input.on('keydown.companyWhisperer', (e) => this.handleKeydown(e));
        this.input.on('focus.companyWhisperer', (e) => this.handleFocus(e));
        this.input.on('blur.companyWhisperer', (e) => this.handleBlur(e));

        this.clearButton.off('click.companyWhisperer');
        this.clearButton.on('click.companyWhisperer', (e) => this.clearInput(e));

        this.suggestionsContainer.off('click.companyWhisperer');
        this.suggestionsContainer.on('click.companyWhisperer', '.company-suggestion', (e) => {
            this.selectSuggestion($(e.currentTarget));
        });

        this.input.on('input.companyWhisperer', () => {
            if (this.input.val().length > 0) {
                this.clearButton.show();
            } else {
                this.clearButton.hide();
            }
        });

        $(document).off('click.companyWhisperer').on('click.companyWhisperer', (e) => {
            if (!$(e.target).closest('.company-whisperer').length) {
                this.hideSuggestions();
            }
        });
    }

    handleInput(e) {
        const query = this.input.val().trim();

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = null;
        }

        if (query === this.lastQuery) {
            return;
        }

        if (query.length < 2) {
            this.lastQuery = query;
            this.hideSuggestions();
            return;
        }

        this.searchTimeout = setTimeout(() => {
            this.searchCompanies(query);
        }, 500);
    }

    handleKeydown(e) {
        if (!this.isVisible) return;

        switch (e.keyCode) {
            case 38: // Arrow up
                e.preventDefault();
                this.navigateUp();
                break;
            case 40: // Arrow down
                e.preventDefault();
                this.navigateDown();
                break;
            case 13: // Enter
                e.preventDefault();
                if (this.currentIndex >= 0) {
                    this.selectSuggestion(this.suggestionsContainer.find('.company-suggestion').eq(this.currentIndex));
                }
                break;
            case 27: // Escape
                this.hideSuggestions();
                break;
        }
    }

    handleFocus(e) {
        const currentQuery = this.input.val().trim();
        if (this.suggestions.length > 0 && currentQuery === this.lastQuery) {
            this.showSuggestions();
        }
    }

    handleBlur(e) {
        setTimeout(() => {
            this.hideSuggestions();
        }, 200);
    }

    async searchCompanies(query) {
        if (this.isSearching) {
            return;
        }

        if (query === this.lastQuery) {
            return;
        }

        this.isSearching = true;
        this.lastQuery = query;
        this.showLoading();

        try {
            if (!this.searchUrl) {
                console.error('Search company URL not available');
                this.displaySuggestions([]);
                return;
            }

            console.log('Searching for company:', query);
            console.log('Using URL:', this.searchUrl);

            const response = await $.ajax({
                url: this.searchUrl,
                method: 'POST',
                data: { companyName: query },
                dataType: 'json',
                timeout: 10000
            });

            console.log('Company search response:', response);

            if (query === this.lastQuery) {
                if (response.success && response.data) {
                    if (Array.isArray(response.data)) {
                        this.displaySuggestions(response.data);
                    } else {
                        this.displaySuggestions([response.data]);
                    }
                } else {
                    this.displaySuggestions([]);
                }
            }

        } catch (error) {
            console.error('Company search failed:', error);
            console.log('Error details:', {
                status: error.status,
                statusText: error.statusText,
                responseText: error.responseText
            });

            if (query === this.lastQuery) {
                this.displaySuggestions([]);
            }
        } finally {
            this.isSearching = false;
        }
    }

    showLoading() {
        this.suggestionsContainer.html(`
            <div class="loading-spinner">
                <i class="fas fa-spinner fa-spin"></i> ${this.texts.searching}
            </div>
        `);
        this.showSuggestions();
    }

    displaySuggestions(companies) {
        this.suggestions = companies;

        if (companies.length === 0) {
            this.suggestionsContainer.html(`
                <div class="no-suggestions">
                    <i class="fas fa-search"></i> ${this.texts.notFound}
                </div>
            `);
        } else {
            const html = companies.map((company, index) => {
                const mainText = company.name || company.obchodniJmeno || this.texts.unknownCompany;
                const detailText = this.formatCompanyDetail(company);

                return `
                    <div class="company-suggestion" data-index="${index}">
                        <div class="suggestion-icon">
                            <i class="fas fa-building"></i>
                        </div>
                        <div class="suggestion-content">
                            <div class="suggestion-main">${mainText}</div>
                            ${detailText ? `<div class="suggestion-detail">${detailText}</div>` : ''}
                            ${company.ico ? `<div class="suggestion-type">IČO: ${company.ico}</div>` : ''}
                        </div>
                    </div>
                `;
            }).join('');

            this.suggestionsContainer.html(html);
        }

        this.currentIndex = -1;
        this.showSuggestions();
    }

    formatCompanyDetail(company) {
        const parts = [];

        if (company.street) {
            parts.push(company.street);
        }

        if (company.city) {
            parts.push(company.city);
        }

        if (company.psc) {
            parts.push(company.psc);
        }

        return parts.join(', ');
    }

    navigateUp() {
        const suggestions = this.suggestionsContainer.find('.company-suggestion');
        if (suggestions.length === 0) return;

        suggestions.removeClass('highlighted');

        if (this.currentIndex <= 0) {
            this.currentIndex = suggestions.length - 1;
        } else {
            this.currentIndex--;
        }

        suggestions.eq(this.currentIndex).addClass('highlighted');
    }

    navigateDown() {
        const suggestions = this.suggestionsContainer.find('.company-suggestion');
        if (suggestions.length === 0) return;

        suggestions.removeClass('highlighted');

        if (this.currentIndex >= suggestions.length - 1) {
            this.currentIndex = 0;
        } else {
            this.currentIndex++;
        }

        suggestions.eq(this.currentIndex).addClass('highlighted');
    }

    selectSuggestion(suggestionElement) {
        const index = parseInt(suggestionElement.data('index'));
        const company = this.suggestions[index];

        if (company) {
            console.log('Selected company:', company);

            if (this.onCompanySelected) {
                this.onCompanySelected(company);
            } else {
                this.fillDefaultFields(company);
            }

            this.hideSuggestions();
            this.clearButton.show();

            toastr.success(this.texts.autofilled);
        }
    }

    fillDefaultFields(company) {
        const nameSelectors = ['#frm-form-form-invoiceName', '#frm-invoiceDataForm-form-invoiceName'];
        const icSelectors = ['#frm-form-form-invoiceIc', '#frm-invoiceDataForm-form-ic'];
        const dicSelectors = ['#frm-form-form-invoiceDic', '#frm-invoiceDataForm-form-dic'];
        const streetSelectors = ['#frm-form-form-invoiceStreet', '#frm-invoiceDataForm-form-street'];
        const citySelectors = ['#frm-form-form-invoiceCity', '#frm-invoiceDataForm-form-city'];
        const zipSelectors = ['#frm-form-form-invoiceZip', '#frm-invoiceDataForm-form-zip'];

        this.fillFirstAvailableField(nameSelectors, company.name || company.obchodniJmeno || '');
        this.fillFirstAvailableField(icSelectors, company.ico || '');
        this.fillFirstAvailableField(dicSelectors, company.dic || '');
        this.fillFirstAvailableField(streetSelectors, company.street || '');
        this.fillFirstAvailableField(citySelectors, company.city || '');
        this.fillFirstAvailableField(zipSelectors, company.psc || '');
    }

    fillFirstAvailableField(selectors, value) {
        for (const selector of selectors) {
            const field = $(selector);
            if (field.length > 0) {
                field.val(value).trigger('change');
                break;
            }
        }
    }

    setOnCompanySelected(callback) {
        this.onCompanySelected = callback;
    }

    showSuggestions() {
        this.suggestionsContainer.show();
        this.isVisible = true;
    }

    hideSuggestions() {
        this.suggestionsContainer.hide();
        this.isVisible = false;
        this.currentIndex = -1;
        this.suggestionsContainer.find('.company-suggestion').removeClass('highlighted');
    }

    clearInput(e) {
        e.preventDefault();
        this.input.val('');
        this.clearButton.hide();
        this.hideSuggestions();
        this.input.focus();
        this.lastQuery = '';

        if (this.onClear) {
            this.onClear();
        } else {
            this.clearDefaultFields();
        }
    }

    clearDefaultFields() {
        const allSelectors = [
            '#frm-form-form-invoiceIc', '#frm-form-form-invoiceDic', '#frm-form-form-invoiceStreet',
            '#frm-form-form-invoiceCity', '#frm-form-form-invoiceZip',
            '#frm-invoiceDataForm-form-ic', '#frm-invoiceDataForm-form-dic', '#frm-invoiceDataForm-form-street',
            '#frm-invoiceDataForm-form-city', '#frm-invoiceDataForm-form-zip'
        ];

        allSelectors.forEach(selector => {
            const field = $(selector);
            if (field.length > 0) {
                field.val('').trigger('change');
            }
        });
    }

    setOnClear(callback) {
        this.onClear = callback;
    }

    destroy() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.input.off('.companyWhisperer');
        this.clearButton.off('.companyWhisperer');
        this.suggestionsContainer.off('.companyWhisperer');
        $(document).off('click.companyWhisperer');
    }
}

window.createCompanyWhisperer = function(inputSelector, suggestionsSelector, searchUrl, options = {}) {
    if (!window.companyWhispererInstances) {
        window.companyWhispererInstances = new Map();
    }

    const key = inputSelector + suggestionsSelector;

    if (window.companyWhispererInstances.has(key)) {
        const existingInstance = window.companyWhispererInstances.get(key);
        existingInstance.destroy();
    }

    const whisperer = new CompanyWhisperer(inputSelector, suggestionsSelector, searchUrl);

    if (options.onCompanySelected) {
        whisperer.setOnCompanySelected(options.onCompanySelected);
    }

    if (options.onClear) {
        whisperer.setOnClear(options.onClear);
    }

    window.companyWhispererInstances.set(key, whisperer);

    return whisperer;
};

window.createCompanySearchButton = function(buttonSelector, searchUrl, fieldMappings) {
    $(buttonSelector).off('click.companySearch');

    $(buttonSelector).on('click.companySearch', function() {
        const icField = $(fieldMappings.ic);
        const nameField = $(fieldMappings.name);

        const companyIco = icField.val();
        const companyName = nameField.val();

        if (!companyIco && !companyName) {
            alert('Zadejte název firmy nebo IČO');
            return;
        }

        const btn = $(this);
        const originalText = btn.html();
        btn.html('<i class="fas fa-spinner fa-spin"></i> Vyhledávám...').prop('disabled', true);

        const searchData = {};
        if (companyIco) {
            searchData.companyIco = companyIco;
        }
        if (companyName) {
            searchData.companyName = companyName;
        }

        $.ajax({
            url: searchUrl,
            method: 'POST',
            data: searchData,
            timeout: 10000,
            success: function(response) {
                if (response.success && response.data) {
                    let companyData;
                    if (Array.isArray(response.data)) {
                        companyData = response.data[0];
                    } else {
                        companyData = response.data;
                    }

                    if (companyData) {
                        $(fieldMappings.name).val(companyData.name || companyData.obchodniJmeno || '');
                        $(fieldMappings.ic).val(companyData.ico || '');
                        $(fieldMappings.dic).val(companyData.dic || '');
                        $(fieldMappings.street).val(companyData.street || '');
                        $(fieldMappings.city).val(companyData.city || '');
                        $(fieldMappings.zip).val(companyData.psc || '');

                        toastr.success('Údaje byly úspěšně dohledány');
                    } else {
                        toastr.error('Firma nebyla nalezena');
                    }
                } else {
                    toastr.error(response.message || 'Firma nebyla nalezena');
                }
            },
            error: function(xhr, status, error) {
                console.error('Company search button error:', error);
                toastr.error('Došlo k chybě při vyhledávání');
            },
            complete: function() {
                btn.html(originalText).prop('disabled', false);
            }
        });
    });
};

class SeznamMapyAddressWhisperer {
    constructor(inputSelector, suggestionsSelector, fieldMappings = {}) {
        this.input = $(inputSelector);
        this.suggestionsContainer = $(suggestionsSelector);
        this.clearButton = this.input.siblings('.clear-address');
        this.currentIndex = -1;
        this.suggestions = [];
        this.searchTimeout = null;
        this.isVisible = false;
        this.lastQuery = '';
        this.isSearching = false;

        this.fieldMappings = {
            street: fieldMappings.street || '#frm-form-form-street',
            city: fieldMappings.city || '#frm-form-form-city',
            zip: fieldMappings.zip || '#frm-form-form-zip',
            latitude: fieldMappings.latitude || '#frm-form-form-latitude',
            longitude: fieldMappings.longitude || '#frm-form-form-longitude'
        };

        // Lokalizované texty (nastavuje šablona přes window.whispererTexts.address); fallback čeština.
        const t = (window.whispererTexts && window.whispererTexts.address) || {};
        this.texts = {
            searching: t.searching || 'Vyhledávám adresy...',
            notFound: t.notFound || 'Žádné adresy nebyly nalezeny',
            unknownAddress: t.unknown || 'Neznámá adresa',
            autofilled: t.autofilled || 'Adresa byla automaticky vyplněna',
        };

        this.apiKey = 'KZTsisSPvzoMBf5BnUY8ngab_b-d_vUL8PafjBCjkvk';
        this.apiBaseUrl = 'https://api.mapy.cz/v1';

        this.init();
    }

    init() {
        this.input.off('input.addressWhisperer keydown.addressWhisperer focus.addressWhisperer blur.addressWhisperer');

        this.input.on('input.addressWhisperer', (e) => this.handleInput(e));
        this.input.on('keydown.addressWhisperer', (e) => this.handleKeydown(e));
        this.input.on('focus.addressWhisperer', (e) => this.handleFocus(e));
        this.input.on('blur.addressWhisperer', (e) => this.handleBlur(e));

        this.clearButton.off('click.addressWhisperer');
        this.clearButton.on('click.addressWhisperer', (e) => this.clearInput(e));

        this.suggestionsContainer.off('click.addressWhisperer');
        this.suggestionsContainer.on('click.addressWhisperer', '.address-suggestion', (e) => {
            this.selectSuggestion($(e.currentTarget));
        });

        this.input.on('input.addressWhisperer', () => {
            if (this.input.val().length > 0) {
                this.clearButton.show();
            } else {
                this.clearButton.hide();
            }
        });

        $(document).off('click.addressWhisperer').on('click.addressWhisperer', (e) => {
            if (!$(e.target).closest('.address-whisperer').length) {
                this.hideSuggestions();
            }
        });
    }

    handleInput(e) {
        const query = this.input.val().trim();

        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = null;
        }

        // If query is same as last query, don't search again
        if (query === this.lastQuery) {
            return;
        }

        if (query.length < 2) {
            this.lastQuery = query;
            this.hideSuggestions();
            return;
        }

        this.searchTimeout = setTimeout(() => {
            this.searchAddresses(query);
        }, 400);
    }

    handleKeydown(e) {
        if (!this.isVisible) return;

        switch (e.keyCode) {
            case 38: // Arrow up
                e.preventDefault();
                this.navigateUp();
                break;
            case 40: // Arrow down
                e.preventDefault();
                this.navigateDown();
                break;
            case 13: // Enter
                e.preventDefault();
                if (this.currentIndex >= 0) {
                    this.selectSuggestion(this.suggestionsContainer.find('.address-suggestion').eq(this.currentIndex));
                }
                break;
            case 27: // Escape
                this.hideSuggestions();
                break;
        }
    }

    handleFocus(e) {
        const currentQuery = this.input.val().trim();
        if (this.suggestions.length > 0 && currentQuery === this.lastQuery) {
            this.showSuggestions();
        }
    }

    handleBlur(e) {
        setTimeout(() => {
            this.hideSuggestions();
        }, 200);
    }

    async searchAddresses(query) {
        if (this.isSearching) {
            return;
        }

        if (query === this.lastQuery) {
            return;
        }

        this.isSearching = true;
        this.lastQuery = query;
        this.showLoading();

        try {
            const url = `${this.apiBaseUrl}/suggest`;
            const params = new URLSearchParams({
                query: query,
                type: 'regional',
                limit: 8,
                lang: 'cs'
            });

            const response = await fetch(`${url}?${params.toString()}`, {
                headers: {
                    'X-Mapy-Api-Key': this.apiKey
                },
                timeout: 10000
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const data = await response.json();

            if (query === this.lastQuery) {
                this.displaySuggestions(data.items || []);
            }

        } catch (error) {
            console.error('Address search failed:', error);

            if (query === this.lastQuery) {
                this.displaySuggestions([]);
            }
        } finally {
            this.isSearching = false;
        }
    }

    showLoading() {
        this.suggestionsContainer.html(`
            <div class="loading-spinner">
                <i class="fas fa-spinner fa-spin"></i> ${this.texts.searching}
            </div>
        `);
        this.showSuggestions();
    }

    displaySuggestions(addresses) {
        this.suggestions = addresses;

        if (addresses.length === 0) {
            this.suggestionsContainer.html(`
                <div class="no-suggestions">
                    <i class="fas fa-search"></i> ${this.texts.notFound}
                </div>
            `);
        } else {
            const html = addresses.map((addr, index) => {
                const icon = this.getAddressIcon(addr);
                const mainText = addr.name || this.texts.unknownAddress;
                const detailText = this.formatAddressDetail(addr);
                const typeText = this.getAddressType(addr);

                return `
                    <div class="address-suggestion" data-index="${index}">
                        <div class="suggestion-icon">
                            <i class="${icon}"></i>
                        </div>
                        <div class="suggestion-content">
                            <div class="suggestion-main">${mainText}</div>
                            ${detailText ? `<div class="suggestion-detail">${detailText}</div>` : ''}
                            ${typeText ? `<div class="suggestion-type">${typeText}</div>` : ''}
                        </div>
                    </div>
                `;
            }).join('');

            this.suggestionsContainer.html(html);
        }

        this.currentIndex = -1;
        this.showSuggestions();
    }

    getAddressType(addr) {
        if (!addr.label) return '';
        return addr.label.toLowerCase();
    }

    getAddressIcon(addr) {
        if (!addr.type) return 'fas fa-map-marker-alt';

        switch (addr.type) {
            case 'regional.address':
                return 'fas fa-home';
            case 'regional.street':
                return 'fas fa-road';
            case 'regional.municipality':
            case 'regional.municipality_part':
                return 'fas fa-city';
            case 'regional.region':
                return 'fas fa-map';
            default:
                return 'fas fa-map-marker-alt';
        }
    }

    formatAddressDetail(addr) {
        const parts = [];

        const municipality = addr.regionalStructure?.find(item => item.type === 'regional.municipality');
        if (municipality && municipality.name) {
            parts.push(municipality.name);
        }

        const region = addr.regionalStructure?.find(item =>
            item.type === 'regional.region' && item.name.startsWith('okres ')
        );
        if (region && region.name) {
            parts.push(region.name);
        }

        if (addr.zip) {
            parts.push(addr.zip);
        }

        return parts.join(', ');
    }

    navigateUp() {
        const suggestions = this.suggestionsContainer.find('.address-suggestion');
        if (suggestions.length === 0) return;

        suggestions.removeClass('highlighted');

        if (this.currentIndex <= 0) {
            this.currentIndex = suggestions.length - 1;
        } else {
            this.currentIndex--;
        }

        suggestions.eq(this.currentIndex).addClass('highlighted');
    }

    navigateDown() {
        const suggestions = this.suggestionsContainer.find('.address-suggestion');
        if (suggestions.length === 0) return;

        suggestions.removeClass('highlighted');

        if (this.currentIndex >= suggestions.length - 1) {
            this.currentIndex = 0;
        } else {
            this.currentIndex++;
        }

        suggestions.eq(this.currentIndex).addClass('highlighted');
    }

    selectSuggestion(suggestionElement) {
        const index = parseInt(suggestionElement.data('index'));
        const address = this.suggestions[index];

        if (address) {
            console.log('Selected address:', address);

            const streetInput = $(this.fieldMappings.street);
            const cityInput = $(this.fieldMappings.city);
            const zipInput = $(this.fieldMappings.zip);
            const latInput = $(this.fieldMappings.latitude);
            const lngInput = $(this.fieldMappings.longitude);

            streetInput.val(this.extractStreetFromAddress(address));
            cityInput.val(this.extractCityFromAddress(address));
            zipInput.val(this.extractZipFromAddress(address));

            if (address.position && latInput.length && lngInput.length) {
                latInput.val(address.position.lat);
                lngInput.val(address.position.lon);

                if (typeof renderLeafletMap === 'function' && this.fieldMappings.street.includes('street')) {
                    renderLeafletMap();
                }
            }

            this.hideSuggestions();
            this.clearButton.show();

            streetInput.add(cityInput).add(zipInput).trigger('change');

            toastr.success(this.texts.autofilled);
        }
    }

    extractStreetFromAddress(address) {
        if (address.name) {
            return address.name;
        }

        const streetItem = address.regionalStructure?.find(item => item.type === 'regional.street');
        const addressItem = address.regionalStructure?.find(item => item.type === 'regional.address');

        if (streetItem && addressItem) {
            return `${streetItem.name} ${addressItem.name}`;
        } else if (streetItem) {
            return streetItem.name;
        }

        return '';
    }

    extractCityFromAddress(address) {
        const municipalityItem = address.regionalStructure?.find(item => item.type === 'regional.municipality');
        return municipalityItem?.name || '';
    }

    extractZipFromAddress(address) {
        return address.zip || '';
    }

    showSuggestions() {
        this.suggestionsContainer.show();
        this.isVisible = true;
    }

    hideSuggestions() {
        this.suggestionsContainer.hide();
        this.isVisible = false;
        this.currentIndex = -1;
        this.suggestionsContainer.find('.address-suggestion').removeClass('highlighted');
    }

    clearInput(e) {
        e.preventDefault();
        this.input.val('');
        this.clearButton.hide();
        this.hideSuggestions();
        this.input.focus();
        this.lastQuery = '';

        if ($(this.fieldMappings.city).length) $(this.fieldMappings.city).val('');
        if ($(this.fieldMappings.zip).length) $(this.fieldMappings.zip).val('');
        if ($(this.fieldMappings.latitude).length) $(this.fieldMappings.latitude).val('');
        if ($(this.fieldMappings.longitude).length) $(this.fieldMappings.longitude).val('');

        $(this.fieldMappings.street + ', ' + this.fieldMappings.city + ', ' + this.fieldMappings.zip).trigger('change');
    }

    destroy() {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        this.input.off('.addressWhisperer');
        this.clearButton.off('.addressWhisperer');
        this.suggestionsContainer.off('.addressWhisperer');
        $(document).off('click.addressWhisperer');
    }
}

window.createAddressWhisperer = function(inputSelector, suggestionsSelector, fieldMappings = {}) {
    if (!window.addressWhispererInstances) {
        window.addressWhispererInstances = new Map();
    }

    const key = inputSelector + suggestionsSelector;

    if (window.addressWhispererInstances.has(key)) {
        const existingInstance = window.addressWhispererInstances.get(key);
        existingInstance.destroy();
    }

    const whisperer = new SeznamMapyAddressWhisperer(inputSelector, suggestionsSelector, fieldMappings);

    window.addressWhispererInstances.set(key, whisperer);

    return whisperer;
};

// === Tlačítko „nahoru" (scroll to top) ===
// Jídelníček bývá dlouhý (5 dnů × několik jídel + přílohy), takže strávník dole na stránce
// scrolluje zpátky nahoru zbytečně dlouho. Tlačítko se objeví po odscrollování a jedním
// klikem vyjede nahoru.
//
// Záměrně JEN na objednávkové stránce (jídelníček) — jinde ve frontu ho zatím nechceme,
// proto guard na #snippet-foodMenu-table. Degraduje: bez toho prvku se nevytvoří vůbec.
//
// Vzor převzatý z administrace (js-less/src/admin/js/default/base.js), styly ale musí být
// samostatné — front má vlastní CSS balíček a admin styly se sem nenačítají.
(function () {
    var THRESHOLD = 300;
    var btn = null;

    function menuPresent() {
        return !!document.getElementById('snippet-foodMenu-table');
    }

    function ensureBtn() {
        if (btn) {
            return btn;
        }
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'scroll-to-top';
        btn.setAttribute('title', 'Nahoru');
        btn.setAttribute('aria-label', 'Zpět nahoru');
        btn.innerHTML = '<i class="fas fa-arrow-up" aria-hidden="true"></i>';
        btn.style.display = 'none';
        btn.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        document.body.appendChild(btn);
        return btn;
    }

    function update() {
        if (!menuPresent()) {
            if (btn) {
                btn.style.display = 'none';
            }
            return;
        }
        var b = ensureBtn();
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        b.style.display = y > THRESHOLD ? 'flex' : 'none';
    }

    var ticking = false;
    function onScroll() {
        if (ticking) {
            return;
        }
        ticking = true;
        window.requestAnimationFrame(function () {
            ticking = false;
            update();
        });
    }

    window.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onScroll);
    $(update);
})();
